import React from 'react'
import { inject, observer } from 'mobx-react'
import { withTranslation } from 'react-i18next'
import { folderActions, bufferAroundPoint, travelTime } from 'constants.js'
import PaneHeader from '../panes/PaneHeader'
import BulkPointBuffer from '../../../stores/BulkPointBuffer'
import BulkIsochrone from '../../../stores/BulkIsochrone'

const FolderActionsPane = ({ uiStore, selectionStore, t }) => {
  const group = selectionStore.data ? selectionStore.data.group : null

  const selectNewItem = (item) => {
    const map = uiStore && uiStore.map && uiStore.map.leafletElement
    const center = map && typeof map.getCenter === 'function' ? map.getCenter() : null
    const zoom = map && typeof map.getZoom === 'function' ? map.getZoom() : null
    if (uiStore && typeof uiStore.suppressMapBoundsTemporarily === 'function') {
      uiStore.suppressMapBoundsTemporarily(450)
    }
    const prevZoomToSelected = uiStore && typeof uiStore.zoomToSelected !== 'undefined' ? uiStore.zoomToSelected : null
    if (uiStore && prevZoomToSelected !== null) {
      uiStore.zoomToSelected = false
    }
    selectionStore.select(item, { data: { group } })
    setTimeout(() => {
      if (map && center && zoom != null) {
        map.setView(center, zoom, { animate: false })
      }
      if (uiStore && prevZoomToSelected !== null) {
        uiStore.zoomToSelected = prevZoomToSelected
      }
    }, 0)
  }

  const handleClose = () => {
    selectionStore.clear()
  }

  return (
    <div className='folder-actions-pane'>
      <PaneHeader
        icon={folderActions}
        title={t('GLOBAL.FOLDER_ACTIONS', { defaultValue: 'Folder actions' })}
        onClose={handleClose}
      />

      <div className='folder-actions-list'>
        <button
          type='button'
          className='folder-action-card'
          onClick={() => selectNewItem(new BulkPointBuffer())}
        >
          <div className='folder-action-card__icon'>
            <span
              style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
              dangerouslySetInnerHTML={{ __html: bufferAroundPoint }}
            />
          </div>
          <div className='folder-action-card__content'>
            <span className='folder-action-card__title'>
              {t('ITEM.CREATE_BUFFER', { defaultValue: 'Create buffer' })}
            </span>
            <span className='folder-action-card__description'>
              {t('ITEM.FOLDER_BUFFER_DESC', { defaultValue: 'Distance around a folder' })}
            </span>
          </div>
          <svg
            className='folder-action-card__chevron'
            width='16'
            height='16'
            viewBox='0 0 24 24'
            fill='none'
            stroke='#64748B'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          >
            <polyline points='9 18 15 12 9 6' />
          </svg>
        </button>

        <button
          type='button'
          className='folder-action-card'
          onClick={() => selectNewItem(new BulkIsochrone())}
        >
          <div className='folder-action-card__icon'>
            <span
              style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
              dangerouslySetInnerHTML={{ __html: travelTime }}
            />
          </div>
          <div className='folder-action-card__content'>
            <span className='folder-action-card__title'>
              {t('ITEM.CREATE_ISOCHRONE', { defaultValue: 'Create isochrone' })}
            </span>
            <span className='folder-action-card__description'>
              {t('ITEM.FOLDER_ISOCHRONE_DESC', { defaultValue: 'Travel time from a folder' })}
            </span>
          </div>
          <svg
            className='folder-action-card__chevron'
            width='16'
            height='16'
            viewBox='0 0 24 24'
            fill='none'
            stroke='#64748B'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          >
            <polyline points='9 18 15 12 9 6' />
          </svg>
        </button>
      </div>
    </div>
  )
}

export default withTranslation()(
  inject('uiStore', 'selectionStore')(observer(FolderActionsPane))
)
